<script>
import { mapState } from 'vuex'
import LadMediaCard from './fragments/media'
import LadDescriptionCard from './fragments/description'

export default {
  name: 'LadCardCommon',
  components: {
    LadMediaCard,
    LadDescriptionCard,
  },
  props: {
    shadow: { type: String, required: true },
    item: { type: Object, required: true, default: () => ({}) },
    base: { type: String, required: true },
    lazy: { type: Boolean, default: false },
    // isProduct: { type: Boolean, default: false },
    to: { type: Object, default: () => ({}) },
    link: { type: String, default: '' },
    target: { type: String, default: '' },
  },
  computed: {
    ...mapState('settings', ['currency']),
  },
}
</script>
